import { api, ReactQueryOptions } from '@api';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['PostsManager']['create'];
export const useCreatePost = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  return api.PostsManager.create.useMutation({
    mutationKey: ['PostsManager.create'],
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    ...options
  });
};